import {
  MediaLibraryDocumentItem,
  MediaLibraryImageItem,
  MediaLibraryImageV1,
  MediaLibraryVideoItem,
} from 'types/MediaLibrary';
import { Asset } from 'types/Attachments';
import { Video } from 'types/Video';
import { AssetStatus } from 'types/AssetStatus';

export function imageToMediaLibraryItem({
  v2,
  additional_info,
  asset_id,
}: MediaLibraryImageV1): MediaLibraryImageItem {
  return {
    id: v2.id,
    ...(asset_id ? { assetId: asset_id } : {}),
    data: {
      ...v2.sizes.lightbox,
      thumbnail: v2.sizes.thumb,
      original: v2.sizes.original,
    },
    meta: {
      usages: 0,
      is_animated_gif: additional_info.is_animated_gif,
      is_panorama: additional_info.is_panorama,
      is_spehrical: additional_info.is_spherical,
    },
    type: 'image',
  };
}

export function unprocessedVideoToMediaLibraryItem(
  id: number,
): MediaLibraryVideoItem {
  return {
    id,
    type: 'video',
    data: { thumbnail: { src: undefined } },
  };
}

export function processedVideoToMediaLibraryItem(
  video: Required<Video>,
): MediaLibraryVideoItem {
  return {
    id: video.id,
    type: 'video',
    ...(video.asset_id ? { assetId: video.asset_id } : {}),
    meta: {
      is_processed: true,
      is_available: true,
      is_error: false,
      duration: video?.meta?.duration ?? 0,
    },
    data: {
      src: video.stream_link,
      height: video.height,
      width: video.width,
      thumbnail: {
        src: video.thumbnail.src,
        height: video.thumbnail.height,
        width: video.thumbnail.width,
      },
    },
  };
}

export function documentToMediaLibraryItem(
  asset: Asset,
): MediaLibraryDocumentItem {
  const src = asset.url ?? '';
  return {
    id: asset.id,
    type: 'document',
    created_at: asset.created_at,
    data: {
      src,
      thumbnail: {
        src,
        width: asset.width ?? 0,
        height: asset.height ?? 0,
      },
    },
    meta: {
      file_name: asset.file_name,
      file_size: asset.file_size,
    },
  };
}

export function imageAssetToMediaLibraryItem(
  asset: Asset,
): MediaLibraryImageItem {
  const src = asset.url ?? '';
  const medium: MediaLibraryImageItem['data']['original'] = {
    src,
    width: asset.width ?? 0,
    height: asset.height ?? 0,
  };
  return {
    id: 0,
    type: 'image',
    assetId: asset.id,
    asset,
    data: {
      src,
      width: asset.width ?? 0,
      height: asset.height ?? 0,
      thumbnail: medium,
      original: medium,
    },
    meta: {
      usages: 0,
      is_animated_gif: asset.type === 'gif',
      is_panorama: false,
      is_spehrical: false,
    },
  };
}

export function videoAssetToMediaLibraryItem(
  asset: Asset,
): MediaLibraryVideoItem {
  return {
    id: 0,
    type: 'video',
    assetId: asset.id,
    asset,
    data: {
      thumbnail: {
        src: asset.poster_url ?? '',
        width: asset.width ?? 0,
        height: asset.height ?? 0,
      },
    },
    meta: {
      duration: 0,
      is_available: asset.status === AssetStatus.READY,
      is_error: asset.status === AssetStatus.FAILED,
      is_processed: asset.status === AssetStatus.READY,
    },
  };
}
